import React from 'react'
import Header from '../components/Header'

const HeaderContainer = ( { scrollToAbout, setShouldScrollToAbout, mainContentRef }) => {
  return (
    <Header scrollToAbout={scrollToAbout} mainContentRef={mainContentRef} setShouldScrollToAbout={setShouldScrollToAbout} />
  )
}

export default HeaderContainer